/* ONLY CHASES · añadir al carrito desde los listados */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var toast, timer;
  function showToast(msg, ok) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'oc-page oc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span>' + msg + '</span>' + (ok ? '<a href="/cart">Ver carrito</a>' : '');
    toast.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.classList.remove('is-on'); }, 3800);
  }
  function cartIcon() {
    var list = document.querySelectorAll('.oc-head__icons a[href*="/cart"]');
    for (var i = 0; i < list.length; i++) { var r = list[i].getBoundingClientRect(); if (r.width && r.bottom > 0) return list[i]; }
    return list[0];
  }
  function setCount(n) {
    document.querySelectorAll('.oc-head__icons a[href*="/cart"]').forEach(function (a) {
      var b = a.querySelector('b'); if (b) b.textContent = n;
      a.setAttribute('aria-label', 'Carrito, ' + n + ' productos');
    });
  }
  function bump() {
    var a = cartIcon(); if (!a || !a.animate) return;
    a.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28) rotate(-8deg)' }, { transform: 'scale(.94)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(.16,1,.3,1)' });
    var b = a.querySelector('b');
    if (b && b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.6)' }, { transform: 'scale(1)' }], { duration: 480, easing: 'ease-out' });
  }
  /* la carta vuela hasta el carrito */
  function fly(btn) {
    return new Promise(function (done) {
      var card = btn.closest('.oc-card');
      var img = card && card.querySelector('.oc-card__img img');
      var a = cartIcon();
      if (reduce || !img || !a || !document.body.animate) { done(); return; }
      var s = img.getBoundingClientRect(), t = a.getBoundingClientRect();
      if (!s.width || t.bottom < 0) { done(); return; }
      var ghost = img.cloneNode(true);
      ghost.removeAttribute('srcset'); ghost.removeAttribute('sizes'); ghost.removeAttribute('loading');
      ghost.src = img.currentSrc || img.src;
      ghost.className = 'oc-fly';
      ghost.style.cssText = 'position:fixed;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height + 'px;object-fit:contain;z-index:300;pointer-events:none;margin:0;filter:drop-shadow(0 18px 30px rgba(0,0,0,.5));transform-origin:center center;will-change:transform,opacity';
      document.body.appendChild(ghost);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      var lift = Math.min(160, Math.max(60, Math.abs(dy) * .25));
      var end = Math.max(.08, 26 / s.width);
      var anim = ghost.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * .18) + 'px,' + (-lift) + 'px) scale(.78) rotate(-10deg)', opacity: 1, offset: .28 },
        { transform: 'translate(' + (dx * .7) + 'px,' + (dy * .55) + 'px) scale(' + (end * 2.2) + ') rotate(8deg)', opacity: 1, offset: .72 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + end + ') rotate(14deg)', opacity: .2, offset: 1 }
      ], { duration: 820, easing: 'cubic-bezier(.45,.05,.55,.95)', fill: 'forwards' });
      anim.onfinish = function () { ghost.remove(); bump(); done(); };
      setTimeout(function () { if (ghost.isConnected) { ghost.remove(); done(); } }, 1400);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oc-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var name = btn.getAttribute('data-oc-name') || 'Producto';
    var req = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-oc-add')), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    req.then(function (res) {
      if (!res.ok) {
        btn.classList.remove('is-busy');
        var d = (res.j && (res.j.description || res.j.message)) || '';
        var already = /already|ya|maximum|todos|all/i.test(d);
        showToast(already ? 'Ya tienes en el carrito todas las unidades de ' + name : 'No se ha podido añadir. Inténtalo desde la ficha.', already);
        return;
      }
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2200);
      var count = fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      fly(btn).then(function () {
        count.then(function (c) { setCount(c.item_count); });
        showToast('<b>' + name + '</b> añadida al carrito', true);
      });
    }).catch(function () { btn.classList.remove('is-busy'); showToast('No se ha podido añadir. Revisa tu conexión.', false); });
  });
})();